import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { productsData } from '../../../data/product';

const slides = [
    {
        id: 1,
        image: "/images/sliders/slide3.jpg",
        title: "Chào mừng bạn đã đến với Bông iu Shop",
        subtitle: "Nơi bảo vệ năng lượng của phái đẹp",
        buttonText: "Khám phá ngay sản phẩm"
    },
    {
        id: 2,
        image: "/images/sliders/slide2.jpg",
        title: "Đá tự nhiên",
        subtitle: "Các mẫu vòng, trang sức đa số được thiết kế và chế tác từ đá tự nhiên",
        buttonText: "Tìm hiểu thêm"
    },
    {
        id: 3,
        image: "/images/sliders/slide1.jpg",
        title: "Mẫu mã mới nhất",
        subtitle: "Cập nhật các mẫu vòng đá hot trend nhất hiện tại",
        buttonText: "Xem sản phẩm"
    }
];

function Home() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();
    const bestsellers = productsData.filter(product => product.bestseller === true);

    // Tự động chuyển slide sau 5 giây
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const formatPrice = (price) => {
        return price.toLocaleString('vi-VN') + ' ₫';
    };

    return (
        <>
            <div className="relative w-full h-screen overflow-hidden">
                {/* Slider Images */}
                {slides.map((slide, index) => (
                    <div
                        key={slide.id}
                        className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'
                            }`}
                    >
                        {/* Background Image */}
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className="w-full h-full object-cover"
                        />

                        {/* Overlay tối */}
                        <div className="absolute inset-0 bg-black/50"></div>

                        {/* Nội dung text */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="text-center text-white px-6 max-w-4xl mx-auto">
                                <h1 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight">
                                    {slide.title}
                                </h1>
                                <p className="text-xl md:text-2xl mb-10 max-w-2xl mx-auto opacity-90">
                                    {slide.subtitle}
                                </p>

                                <button
                                    onClick={() => navigate('/products')}
                                    className="px-10 py-4 bg-white text-gray-900 font-semibold rounded-full text-lg hover:bg-gray-100 transition transform hover:scale-105 active:scale-95"
                                >
                                    {slide.buttonText}
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Nút Previous & Next */}
                <button
                    onClick={prevSlide}
                    className="absolute left-6 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-4 rounded-full transition z-10"
                >
                    ←
                </button>

                <button
                    onClick={nextSlide}
                    className="absolute right-6 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white p-4 rounded-full transition z-10"
                >
                    →
                </button>

                {/* Dots Indicator */}
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3 z-10">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => goToSlide(index)}
                            className={`w-3 h-3 rounded-full transition-all ${index === currentSlide
                                ? 'bg-white scale-125'
                                : 'bg-white/50 hover:bg-white/70'
                                }`}
                        />
                    ))}
                </div>
            </div>

            {/* Best seller */}
            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-gray-800 mb-4">
                        Sản phẩm bán chạy
                    </h2>
                    <p className="text-gray-600 text-lg">
                        Những món trang sức được nhiều chị em yêu thích nhất
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {bestsellers.map((product) => (
                        <div
                            key={product.id}
                            className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group"
                        >
                            <div className="relative">
                                <img
                                    src={product.image}
                                    alt={product.name}
                                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                                {product.stock < 20 && (
                                    <div className="absolute top-3 right-3 bg-red-500 text-white text-xs px-3 py-1 rounded-full font-medium">
                                        bán chạy
                                    </div>
                                )}
                            </div>

                            <div className="p-5">
                                <div className="text-sm text-blue-600 font-medium mb-1">{product.category}</div>
                                <h3 className="font-semibold text-lg text-gray-800 line-clamp-2 mb-3 min-h-[56px]">
                                    {product.name}
                                </h3>

                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-2xl font-bold text-gray-900">
                                            {formatPrice(product.price)}
                                        </p>
                                        <p className="text-xs text-gray-500">Còn {product.stock} sản phẩm</p>
                                    </div>

                                    {/* <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl font-medium transition flex items-center gap-2">
                                    Thêm vào giỏ
                                </button> */}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {bestsellers.length === 0 && (
                    <p className="text-center text-gray-500 py-10">
                        Chưa có sản phẩm bán chạy nào.
                    </p>
                )}
            </div>
        </>
    );
}

export default Home;